import { render } from "./ActiveCampaignsList.vue?vue&type=template&id=eb27f4b2&scoped=true"
import script from "./ActiveCampaignsList.vue?vue&type=script&lang=ts"
export * from "./ActiveCampaignsList.vue?vue&type=script&lang=ts"

import "./ActiveCampaignsList.vue?vue&type=style&index=0&id=eb27f4b2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-eb27f4b2"

export default script